let defaultState = {
  proposalNameFilter: "",
  proposalClientFilters: [],
  proposalLeadFilters: [],
  proposalClientManagerFilters: [],
  proposalAnalystFilters: [],
  proposalStatusFilters: [],
  proposalMetadataValuesFilters: [],
  proposalSortType: "-created_date",
  proposalCategoryFilters: [],
}

export default function manageProposalFilters(state = defaultState, action) {
  switch (action.type) {
    case "HANDLE_CHANGE_PROPOSAL_FILTER":
      return { ...state, ...action.payload }
    case "HANDLE_CHANGE_PROPOSAL_METADATA_FILTER":
      const { metadata, values } = action.payload
      const filteredValues = state.proposalMetadataValuesFilters.filter(val => {
        return val.proposal_metadata !== metadata.url
      })
      const proposalMetadataValuesFilters = [...filteredValues, ...values]
      return { ...state, proposalMetadataValuesFilters }
    case "CLEAR_PROPOSAL_ADVANCED_FILTERS":
      return { ...state, proposalMetadataValuesFilters: [] }
    case "CLEAR_ALL_PROPOSAL_FILTERS":
      return {
        ...state,
        proposalNameFilter: "",
        proposalClientFilters: [],
        proposalLeadFilters: [],
        proposalClientManagerFilters: [],
        proposalStatusFilters: [],
        proposalMetadataValuesFilters: [],
        proposalCategoryFilters: [],
      }
    default:
      return state
  }
}

export const handleChangeProposalFilter = (filterType, value) => {
  const payload = { [filterType]: value }
  return { type: "HANDLE_CHANGE_PROPOSAL_FILTER", payload }
}

export const handleChangeProposalMetadataFilter = (metadata, values) => {
  const payload = { metadata, values }
  return { type: "HANDLE_CHANGE_PROPOSAL_METADATA_FILTER", payload }
}

export const clearAdvancedFilters = () => {
  return { type: "CLEAR_PROPOSAL_ADVANCED_FILTERS"}
}

export const clearAllProposalFilters = () => {
  return { type: "CLEAR_ALL_PROPOSAL_FILTERS"}
}



// WEBPACK FOOTER //
// ./src/routes/proposals/reducers/manageProposalFilters.js